module.exports = __webpack_public_path__ + "img/headselect.89904a38.png";